import React from "react";
import Layout from "../components/Layout";
import { useLang } from "../contexts/LanguageContext";
import { coachesFr, coachesEn } from "../data/team";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Team() {
  const { t, lang } = useLang();
  const coaches = lang === "fr" ? coachesFr : coachesEn;

  return (
    <Layout>
      <section data-testid="team-hero" className="relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1518093791220-e3e44b4ebf1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="" className="absolute inset-0 w-full h-full object-cover editorial-img opacity-[0.18]" />
          <div className="absolute inset-0 bg-gradient-to-b from-ivory via-ivory/85 to-ivory" />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
          <h1 className="font-serif text-2xl md:text-3xl font-light text-brand uppercase tracking-[0.08em] leading-snug">
            {t.team_page.eyebrow}
          </h1>
        </div>
      </section>

      <section className="px-6 md:px-10 max-w-[1400px] mx-auto pb-12">
        <div className="inline-flex items-center gap-3 bg-brand/10 border-l-2 border-brand py-3 px-5" data-testid="team-certification">
          <span className="text-sm md:text-base text-navy font-light">{lang === "fr" ? "Nos consultants sont certifiés et supervisés." : "Our consultants are certified and supervised."}</span>
        </div>
      </section>

      <section className="px-6 md:px-10 max-w-[1400px] mx-auto pb-24 md:pb-32 space-y-24 md:space-y-32">
        {coaches.map((c, i) => (
          <article key={c.id} data-testid={`coach-${c.id}`} className="grid grid-cols-12 gap-8 md:gap-12 items-start">
            <div className={`col-span-12 md:col-span-5 ${i % 2 === 1 ? "md:order-2" : ""}`}>
              <div className="aspect-[4/5] overflow-hidden bg-sand">
                <img src={c.photo} alt={c.name} className="w-full h-full object-cover editorial-img" loading="lazy" />
              </div>
            </div>
            <div className={`col-span-12 md:col-span-7 ${i % 2 === 1 ? "md:order-1" : ""}`}>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] font-light text-navy tracking-tight">{c.name}</h2>
              <div className="text-ink/60 text-base mt-3 italic">{c.role}</div>

              <div className="hairline bg-black mt-8 mb-8 w-24"></div>

              <div className="space-y-5">
                {c.bio.map((p, idx) => (
                  <p key={idx} className="text-ink/80 leading-relaxed text-base md:text-lg font-light">{p}</p>
                ))}
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-10">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand mb-3">{t.team_page.credentials}</div>
                  <ul className="space-y-1.5 text-sm text-ink/75">
                    {c.credentials.map((cr) => <li key={cr}>{cr}</li>)}
                  </ul>
                </div>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand mb-3">{t.team_page.languages}</div>
                  <div className="text-sm text-ink/75">{c.languages.join(" · ")}</div>
                </div>
              </div>
            </div>
          </article>
        ))}
      </section>

      <section className="bg-sand py-20 px-6 md:px-10">
        <div className="max-w-[1400px] mx-auto border border-navy/15 p-10 md:p-16 bg-ivory flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <p className="font-serif text-3xl md:text-4xl font-light leading-tight max-w-2xl text-navy">{t.team_page.cta_title}</p>
          <Link to="/contact" data-testid="team-cta" className="group inline-flex items-center gap-2 bg-brand hover:bg-brandDark text-white px-3 py-2 transition-colors flex-none">
            <span className="text-[10px] tracking-[0.22em] uppercase font-mono">{t.home.final_cta}</span>
            <ArrowUpRight size={12} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </div>
      </section>
    </Layout>
  );
}
